import { assertEvent, fromPromise, setup } from 'xstate5'
import { assertFriendlyError } from '@/functional/friendlyErrors'
import { type Emits as EmitsDefaultViewsPure } from '@/components/PmDefaultViews/PmDefaultViewsPure.vue'

export const PmDefaultViewsState = setup({
  types: {
    events: {} as {
      type: 'submit'
      variables: EmitsDefaultViewsPure['submit'][0]
    },

    context: {} as {
      error: string | undefined
      errorDetails: string[] | undefined
    },
  },

  actions: {
    showSuccessNotification: () => {
      throw new Error('showSuccessNotification not implemented')
    },
  },

  actors: {
    save: fromPromise<void, { variables: EmitsDefaultViewsPure['submit'][0] }>(
      async () => {
        throw new Error('save not implemented')
      }
    ),
  },
}).createMachine({
  id: 'PmDefaultViewsState',
  initial: 'default',

  context: {
    error: undefined,
    errorDetails: undefined,
  },

  states: {
    default: {
      on: {
        submit: 'saving',
      },
    },

    saving: {
      invoke: {
        id: 'save',
        src: 'save',
        input: ({ event }) => {
          assertEvent(event, 'submit')
          return { variables: event.variables }
        },
        onDone: {
          target: 'success',
          actions: 'showSuccessNotification',
        },
        onError: {
          target: 'error',
          actions: ({ context, event }) => {
            assertFriendlyError(event.error)
            context.error = event.error.message
            context.errorDetails = event.error.details
          },
        },
      },
    },

    success: {
      on: {
        submit: 'saving',
      },
    },

    error: {
      on: {
        submit: 'saving',
      },
    },
  },
})
